import { render } from "./lang-msg-box.vue?vue&type=template&id=4197d0e4&scoped=true&ts=true"
import script from "./lang-msg-box.vue?vue&type=script&lang=ts"
export * from "./lang-msg-box.vue?vue&type=script&lang=ts"

import "./lang-msg-box.vue?vue&type=style&index=0&id=4197d0e4&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4197d0e4"]])

export default __exports__